import React, { useCallback, useEffect }  from "react"
import { navigate } from '@reach/router'
import { connect } from 'react-redux'
import { blockUnenrolledStudent, getUnenrolledStudent, resetUnenrolledStudent } from '../../../redux/actions/unenrolledStudentSelected'
import { handleExpiredAuthState } from '../../../redux/actions/authActions'
import Skeleton from 'react-loading-skeleton'
import CandidateInfo from '../../../components/CandidateInfo'
import  Documents  from '../../../components/Documents'
import "./Details.css"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { RefreshButton } from "../../../components/RefreshButton"
import { Container, Row, Col } from 'react-bootstrap'
import { BackListButton } from '../../../components/BackListButton'
import { DEFAULT_PERIOD_VALUE } from "../../../constants/periods"
import { getAllPeriods } from '../../../redux/actions/periodActions'
import { ApiException, ExpiredSessionException } from "../../../api/exceptions"

const Details = ({ controlNumber, unenrolledStudent, getUnenrolledStudent, blockUnenrolledStudent, resetUnenrolledStudent, handleExpiredAuthState, getAllPeriods, periods}) => {

  const {info, documents, isLoading, error, message } = unenrolledStudent
  const alert = withReactContent(Swal)

  const updateBlockedStudent = () => {
    if( info.inscripcion ){
      blockUnenrolledStudent(controlNumber)
      .catch( error => {
        if (error instanceof ExpiredSessionException) {
          return handleExpiredAuthState();
        }

        alert.fire({
          title: (error instanceof ApiException) ? error.message : 'Hubo un error al apartar el estudiante. Intente más tarde.',
          icon: 'error'
        })
      })
    }
  }

  useEffect(() => {
    !periods.length && getAllPeriods()
  }, [periods.length])

  /** get student information */
  useEffect(() => {
    getUnenrolledStudent(controlNumber)
  }, [controlNumber])

/** Show error */
  useEffect(() => {
    if (error){
      alert.fire({
        title: message,
        icon: 'error',
        confirmButtonText: 'Aceptar',
        preConfirm: () => {
          resetUnenrolledStudent()
          navigate('/admin/inicio')
        }
      })
    } 
  }, [error])

  /** send request to block 29seconds*/
  useEffect(() => {
    const timer = setInterval(() => {
      updateBlockedStudent()
    }, 29000)
    return () =>  clearInterval(timer)
  }, [info])

  /** tell wether the student can be enrolled/unenrolled */
  const isFromCurrentPeriod = useCallback(() => {
    if (info.inscripcion?.periodo) {
      const period = periods.find(p => p.label === info.inscripcion.periodo.nombre)

      return period?.value === DEFAULT_PERIOD_VALUE;
    }

    return false
  }, [info.inscripcion, periods.length]);

  return (
    <Container>
    <Row className="position-sticky" style={{ top: '67px', zIndex: 2}}>
      <Col className="bg-white">
        <h1>Documentaci&oacute;n</h1>
      </Col>
      <Col className="bg-white col-md-3 col-lg-2 d-flex justify-content-between align-items-center">
        <RefreshButton updateHandler={() => getUnenrolledStudent(controlNumber)} />
        <BackListButton />
      </Col>
      <hr />
    </Row>
      <hr />
      { isLoading 
        ? <>
          <Skeleton height={200} />
          <Skeleton height={700} />
        </>  
        : <>
            <CandidateInfo info={info} />
            <Documents allowEnrollmentStateToggle={isFromCurrentPeriod()} documents={documents} controlNumber={controlNumber} slugStudent={info.slug} updateHandler={() => getUnenrolledStudent(controlNumber)} inscrito={info.inscripcion && info.inscripcion.inscrito} nss={info.numero_de_seguro_social} equivalencia={info.inscripcion && info.inscripcion.equivalencia} /> 
          </>
      }
    </Container>
  );
};

const mapStateToProps = state => ({
  unenrolledStudent : state.unenrolledStudentSelectedInfo,
  periods : state.periodsReducer
})

const mapDispatchToProps = {
  getUnenrolledStudent,
  blockUnenrolledStudent,
  resetUnenrolledStudent,
  handleExpiredAuthState,
  getAllPeriods,
}

export default connect(mapStateToProps,mapDispatchToProps)(Details)
